module.exports = __webpack_public_path__ + "img/1_no.9afa0412.svg";